<div class="karaoke-entry rs_preserve">
    @if (textEntryId) {
    <div class="karaoke-entry__icon">
        <read-speaker-button [readId]="textEntryId"></read-speaker-button>
    </div>
    }

    <div class="karaoke-entry__text">
        <ng-content></ng-content>
    </div>
</div>
